export const AddonScheduleMode = {
    Everyday: 'everyday',
    SelectDays: 'select_days'
} as const;

export type AddonScheduleMode = (typeof AddonScheduleMode)[keyof typeof AddonScheduleMode];

// One schedule per pet and Add-On. Everyday uses `quantity` for every eligible day;
// Select Days uses `days` (date -> quantity), and a date left out gets no occurrence.
export interface AddonSchedule {
    mode: AddonScheduleMode;
    quantity: number;
    days: Record<string, number>;
}

export interface AddonOccurrence {
    date: string;
    quantity: number;
}
